export default __webpack_public_path__ + "static/media/gallery_01.2b7653d9.jpg";